import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class Cloudflare extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M16.531,14.73a1.418,1.418,0,0,0-.149-1.294,1.542,1.542,0,0,0-1.046-.548l-8.664-.1c-.05,0-.1-.049-.149-.049a.094.094,0,0,1,0-.15c.05-.1.1-.149.2-.149l8.714-.1a3.133,3.133,0,0,0,2.539-1.892l.5-1.294c0-.05.05-.1,0-.15a5.675,5.675,0,0,0-10.9-.6,2.712,2.712,0,0,0-1.792-.5A2.594,2.594,0,0,0,3.485,10.2a2.733,2.733,0,0,0,.05.9A3.636,3.636,0,0,0,0,14.73a2.036,2.036,0,0,0,.05.548.158.158,0,0,0,.149.149H16.183c.1,0,.2-.049.2-.149Z" />
        <path d="M19.27,9.154h-.249c-.05,0-.1.049-.15.1l-.348,1.2a1.421,1.421,0,0,0,.149,1.3,1.541,1.541,0,0,0,1.046.547l1.842.1c.05,0,.1.05.15.05a.094.094,0,0,1,0,.149c-.05.1-.1.15-.2.15l-1.892.1a3.133,3.133,0,0,0-2.539,1.892l-.1.448c-.05.05,0,.15.1.15h6.572a.133.133,0,0,0,.15-.15,5.436,5.436,0,0,0,.2-1.294,4.76,4.76,0,0,0-4.73-4.73" />
      </svg>
    );
  }
}

export default Cloudflare;
